// eslint-disable-next-line no-restricted-imports -- this is the only place where we can import i18next
import i18n from 'i18next'

// eslint-disable-next-line no-restricted-imports -- this is the only place where we can import react-i18next
import {
  initReactI18next,
  useTranslation as useTranslationI18n,
  withTranslation,
  Trans
} from 'react-i18next'

import ptBR from './translations/pt-BR.json'
import enUS from './translations/en-US.json'
import es from './translations/es.json'
import nonEducational from './translations/non-educational.json'
import { useCallback } from 'react'
import { getCookie } from 'utils/cookies'

export type LanguageTokens = keyof typeof ptBR['translation']

export const SELECTED_LANGUAGE_COOKIE_NAME = 'language'
export const ONE_YEAR_IN_DAYS = 365

export const PT_BR_LANGUAGE = 'pt-BR'
export const EN_US_LANGUAGE = 'en-US'
export const ES_LANGUAGE = 'es'
export const NON_EDUCATIONAL_LANGUAGE = 'nonEducational'

export type AvailableLanguages =
  | typeof PT_BR_LANGUAGE
  | typeof EN_US_LANGUAGE
  | typeof ES_LANGUAGE
  | typeof NON_EDUCATIONAL_LANGUAGE

export const DOCUMENT_LANGUAGE_BY_APP_LANGUAGE: Record<string, string> = {
  [PT_BR_LANGUAGE]: PT_BR_LANGUAGE,
  [EN_US_LANGUAGE]: EN_US_LANGUAGE,
  [ES_LANGUAGE]: ES_LANGUAGE,
  [NON_EDUCATIONAL_LANGUAGE]: PT_BR_LANGUAGE
}

export const syncDocumentLanguage = (language?: string) => {
  document.documentElement.lang =
    (language && DOCUMENT_LANGUAGE_BY_APP_LANGUAGE[language]) || PT_BR_LANGUAGE
}

i18n.use(initReactI18next).init({
  fallbackLng: getCookie(SELECTED_LANGUAGE_COOKIE_NAME) || PT_BR_LANGUAGE,
  interpolation: {
    escapeValue: true
  },
  resources: {
    [PT_BR_LANGUAGE]: ptBR,
    [EN_US_LANGUAGE]: enUS,
    [ES_LANGUAGE]: es,
    [NON_EDUCATIONAL_LANGUAGE]: nonEducational
  },
  nsSeparator: false
})

i18n.on('languageChanged', syncDocumentLanguage)
syncDocumentLanguage(
  i18n.language || getCookie(SELECTED_LANGUAGE_COOKIE_NAME) || PT_BR_LANGUAGE
)

const useTranslation = () => {
  const { i18n, t: translate } = useTranslationI18n()

  const t = useCallback(
    (text: LanguageTokens, options?: object) => translate(text, options),
    [translate]
  )

  const changeLanguage = useCallback(
    (lang: AvailableLanguages) => i18n.changeLanguage(lang),
    [i18n]
  )

  return { i18n, t, changeLanguage }
}

const getLanguages = (t, nonEducationalLanguage?: boolean) => {
  return [
    {
      value: nonEducationalLanguage ? NON_EDUCATIONAL_LANGUAGE : PT_BR_LANGUAGE,
      label: t('Português')
    },
    {
      value: EN_US_LANGUAGE,
      label: t('Inglês')
    },
    {
      value: ES_LANGUAGE,
      label: t('Espanhol')
    }
  ] as const
}

export { useTranslation, i18n, withTranslation, getLanguages, Trans }
